<template>
  <div class="room"
       data-grm-comp="RoomCamStudy"
       :data-roomid="room.roomId"
       :data-groupid="room.groupId"
       :data-roomType="room.roomType"
       :data-open-extend-menu="isOpenExtendMenu"
  >
    <template v-if="readyToEnter && !isLeaved">
<!--      <Battery style="position:absolute; left: 75px; top: 55px; z-index: 9; color: #fff; font-size: 14px; text-shadow: 1px 1px #000;"></Battery>-->
<!--      <RoomMenu-->
<!--        :isOpenExtendMenu="isOpenExtendMenu"-->
<!--        :isOpenRoomStickerModal.sync="isOpenRoomStickerModal"-->
<!--        :v2CamsHomeUrl="v2CamsHomeUrl"-->
<!--      />-->
      <div class="room-container">
<!--        <RoomControls-->
<!--          :isOpenExtendMenu.sync="isOpenExtendMenu"-->
<!--        />-->
        <div style="flex: 1; min-height: 0; display: flex; flex-direction: column;">
          <CamstudyRoomInfo
              :roomInfo="room"
              :class="{visible: isOpenControlMenu || !isMobile}"
          />
          <div class="room-main" @click="onToggleControlMenu">

            <transition-group name="fade">
              <component class="room-main-component" key="room-main" v-if="!isRoomMode('media')" :is="roomMainComponent" />
            </transition-group>

            <RoomCallConnectionState
                style="position: absolute; z-index: 10; top: 0px; left: 0; pointer-events: none;"
                v-if="showConnectionStats === true"
            />
<!--
            <div ref="scanLine" class="scanline-default" style="z-index: 9"
                 :style="{
                  opacity: lowPowerMode > 0 ? 1 : 0
                }"
            ></div>
            -->

            <Loading v-if="showRoomConnectionStateLoading" :msg="$t('room.connectionState.msg.' + connectionState)" />
            <GrmSnackbarList :isOpenExtendMenu="isOpenExtendMenu" />
          </div>
          <CamstudyWhiteNoiseAudio/>
          <CamstudyControl :v2CamsHomeUrl="v2CamsHomeUrl"
              :isOpenControlMenu="isOpenControlMenu"
              :roomInfo="room"
              :class="{visible: isOpenControlMenu || !isMobile}"
          />
          <!--
          <RoomExtendMenu :class="{ isOpen: isOpenExtendMenu }"
                          @closeExtendMenu="closeExtendMenu"
                          @toggleNewWindowMenu="toggleNewWindowMenu"
                          @transitionend.native="onTransitionend"
                          ref="roomExtendMenu"/>
          -->
          <RoomWindowOpen
              ref="newWindowMenu"
              :title="`[Gooroomee-PIP] ${$t('setting.chat.title')}`"
              :width="320"
              :minWidth="320"
              :height="800"
              :minHeight="800"
          >
            <RoomExtendMenu
                :chatHistoryProp="chatHistory()"
                newWindow/>
          </RoomWindowOpen>

<!--          <RoomNotification :isOpenExtendMenu="isOpenExtendMenu"
                            @openExtendMenu="isOpenExtendMenu = true"
          />-->
        </div>
      </div>
      <PremiumPlusModal v-if="isOpenPlusModal" @close="onClosePremiumPlusModal" />
    </template>
    <template v-else>
      <CamstudyDeviceSetting
          v-if="isShowSetDevice"
          :roomInfo="room"
          :deviceSettings="deviceSettings"
          isDevicetest
          ref="waitingRoom"
          @onUpdateReqEnterNickname="setUserNickname"
      />
    </template>
  </div>
</template>

<script>
import {} from "@/core/api/camstudy/room.camstudy.api";
import {} from "@/core/api/room.ux.api";
import {} from "@/core/api/room.call.api"
import {} from "@/core/api/room.call.stream.api"
import {} from "@/core/api/room.call.p2p.api"
import {} from "@/core/api/room.call.log.api"
import {} from "@/core/api/room.group.api"
import {} from "@/core/api/room.chat.api";

import {} from "@/core/api/room.user.behavior.api";
import {} from "@/core/api/camstudy/room.user.vacancy.api";
import {} from "@/core/api/camstudy/room.user.videoTrackFilter.api";
import {} from "@/core/api/camstudy/room.user.faceDetector.api";
import {} from "@/core/api/group.api";
import {} from "@/core/api/camstudy/room.camstudy.api";

import {} from "@/core/api/test/room.dev-test.api";

import _ from "lodash";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import Vue from "vue";
import { i18n } from "@/locales/i18n";

// import CamstudyMenu from "@/components/Room/Camstudy/Menu.vue
// import RoomSetting from '@/components/Room/Setting/RoomSetting.vue'
import RoomControls from '@/components/Room/Controls/RoomControls.vue'
import RoomCallSubVideo from '@/components/Room/Call/SubVideo'
import RoomExtendMenu from '@/components/Room/ExtendMenu/RoomExtendMenu'
import RoomCall from '@/components/Room/Call/RoomCall'
import RoomDocShare from '@/components/Room/Doc/Share'
import RoomMediaShare from '@/components/Room/Media/Share'
import RoomExam from '@/components/Room/Exam/RoomExam.vue'
import RoomCBT from '@/components/Room/CBT/RoomCBT.vue'
import RoomStickerModal from '@/components/Room/Sticker/Modal'
import ModalInvite from "@/components/Room/Invite/RoomInvite";
import RoomCallConnectionState from "@/components/Room/Call/RoomCallConnectionState";
import RoomMirroring from "@/components/Room/Mirroring/RoomMirroring";
// import RoomDeviceSetting from "@/components/Room/DeviceSetting/RoomDeviceSetting";
import CamstudyDeviceSetting from "@/components/Room/DeviceSetting/coordi/CamstudyDeviceSetting.vue"
import RoomWindowOpen from "@/components/Room/Window/RoomWindowOpen";
import RoomJoinGuest from "@/components/Room/Join/RoomJoinGuest";
import Loading from "@/components/Common/loading/GrmLoading.vue"
import Battery from "@/components/Common/battery/Battery.vue"
import CamstudyControl from "@/components/Room/Camstudy/Control.vue"
import CamstudyRoomInfo from "@/components/Room/Camstudy/RoomInfo.vue"

import commonEventListener from "@/store/plugins/common.event.listener";
import roomEventListener from "@/store/plugins/room.event.listener";

import {closeWindow} from "@/core/api/util.api";
import {Device} from "@/utils";
import {getCamStudyV2HomeUrl, getCamStudyV2RootUrl} from '@/utils/CamStudyV2Helper'
import GrmSnackbarList from "@/components/Common/snackbar/GrmSnackbarList";
import RoomNotification from "@/components/Room/Notification/RoomNotification";
import RoomCallP2P from "@/components/Room/Call/p2p/RoomCallP2P.vue";
import {GrmWebRTC} from "@/lib/gooroomee/webrtc/GrmWebRTC";
import RoomCallAudio from "@/components/Room/Call/RoomCallAudio.vue";
import CamstudyWhiteNoiseAudio from "@/components/Room/Camstudy/WhiteNoiseAudio.vue";
import GrmTransitionLoading from "@/components/Common/loading/GrmTransitionLoading.vue";
import dayjs from 'dayjs'
import PremiumPlusModal from "@/components/Room/DeviceSetting/PremiumPlusModal.vue";

export default {
  name: "RoomCamStudy",
  props: {
    room: Object,
  },
  components: {
    PremiumPlusModal,
    GrmTransitionLoading,
    RoomCallAudio,
    RoomCallP2P,
    RoomNotification,
    GrmSnackbarList,
    RoomControls,
    // RoomSetting,
    RoomCallSubVideo,
    RoomExtendMenu,
    RoomCall,
    RoomDocShare,
    RoomMediaShare,
    RoomExam,
    RoomCBT,
    RoomStickerModal,
    ModalInvite,
    CamstudyDeviceSetting,
    RoomCallConnectionState,
    RoomMirroring,
    RoomWindowOpen,
    Loading,
    Battery,
    CamstudyWhiteNoiseAudio,
    CamstudyControl,
    CamstudyRoomInfo
  },
  data() {
    return {
      rv_test: true,

      readyToEnter: false,
      isShowSetNickname: false,
      isLeaveRoom: false,
      isSetDeviceLoading: false,
      isShowSetDevice: false,
      passwd: '',

      // deviceSettings: null,
      user: null,
      roomUserNickname: '',
      enterReq: {
        nickname: ''
      },

      // 3.0
      isOpenExtendMenu: !Device.isMobile(),
      // isOpenRoomSetting: false,
      isOpenRoomStickerModal: false,
      v2CamsHomeUrl: '',
      isOpenPlusModal: false,
    }
  },
  computed: {
    ...mapGetters('room', [
        'connectionState',
        'isLeaved',
        'roomDataInitComplete', 'deviceSettings',
        'isRoomMode',
        'roomMode',
        'isModalDeviceSetting',
        'lowPowerMode'
    ]),
    ...mapGetters('common', [
      'notify',
      'alert',
      'isOpenVoiceRequest',
      'isOpenControlMenu'
    ]),
    ...mapGetters('user', [
       'isMe',
       'hasEmceeRole',
       'getRoomUser',
       'isOpener',
       'isParticipantRole',
       'me'
    ]),
    ...mapGetters('roomSetting',['roomSetting']),
    ...mapGetters('call',['showConnectionStats']),
    ...mapGetters('camstudy', ['personalSetting', 'isUserTrialEnabledBy']),
    ...mapState('cbt', [
      'roomCBT'
    ]),
    isMobile(){
      return Device.isMobile();
    },
    chatHistory(){
      return ()=>{
        return this.$refs.roomExtendMenu?.chatHistory;
      }
    },
    roomId() {
      return this.room?.room?.roomId
    },
    roomMainComponent() {
      switch (this.roomMode) {
        case 'call':
        case 'screenShare':
        case 'group':
          return 'RoomCall'
        case 'doc':
          return 'RoomDocShare'
        case 'media':
          return 'RoomMediaShare'
        case 'exam':
          return 'RoomExam'
        case 'CBT':
          return this.roomCBT.roomCbtId ? 'RoomCBT' : ''
        case 'mirroring':
          return 'RoomMirroring'
        default:
          return ''
      }
    },
    showRoomConnectionStateLoading() {
      const loadingConnectionStates = ['ready', 'retry'];
      return loadingConnectionStates.includes(this.connectionState);
    },
  },
  beforeCreate() {
    try{
      ['theme-color', 'apple-mobile-web-app-status-bar-style'].forEach(name => {
        let meta = document.querySelector(`meta[name="${name}"]`);
        if(!meta){
          meta = document.createElement('meta');
          meta.setAttribute('name', name);
          document.querySelector('head').append(meta);
        }
        meta.setAttribute('content', '#1f1f1f');
      });
    }catch(e){
      console.error(e);
    }
  },
  async created() {
    this._events = _.clone(_Events);
    this.$roomApi.addEventListeners(this._events, this);
    this.getDocument().addEventListener('fullscreenchange', this.onFullscreenChange);

    // test
    window.$rv = this;

    await this.roomEnter();
    document.addEventListener('visibilitychange', (() => {
      this.__default_visibilitychange = this.__default_visibilitychange || (e => {
        const {visibilityState} = document;
        this.DOCUMENT_VISIBILITY_STATE({visibilityState});
      });
      return this.__default_visibilitychange;
    })());

    // this.isOpenPlusModal = !localStorage.getItem('premium-plus-close-forever');
    this.isOpenPlusModal = !document.cookie.includes('premium_plus_close_forever=true');
  },
  mounted() {
    this.v2CamsHomeUrl = getCamStudyV2HomeUrl()
  },
  destroyed() {
    if(this.__default_visibilitychange){
      document.removeEventListener('visibilitychange', this.__default_visibilitychange);
    }

    this.$roomApi.removeEventListeners(this._events);
    this.getDocument().removeEventListener('fullscreenchange', this.onFullscreenChange);
    this.setVisibilityLowPowerModeListener(true);
  },
  methods: {
    ...mapActions('room', [
      'enter',
      'reloadRoom',
      'checkSilentReload',
      'saveDeviceSettings',
      'getRoom',
      'unsetBeforeUnloadEvent',
      'setRoomInfo',
      'reqLeave'
    ]),
    ...mapActions('user', [
      'getMyNickname'
    ]),
    ...mapActions('auth', [
      'guestLogin',
      'currentUser'
    ]),
    ...mapActions('ux', [
      'setUXInfo',
    ]),
    ...mapActions('common', [
        'toggleControlMenu',
    ]),
    ...mapMutations('room', [
       'SET_FULL_SCREEN',
       'ROOM_CONNECTED',
       'CHANGE_LOW_POWER_MODE',
        'DOCUMENT_VISIBILITY_STATE',
    ]),
    onToggleControlMenu(e) {
      if(e.target.nodeName === 'BUTTON'){
        return;
      }

      this.toggleControlMenu()
    },
    setVisibilityLowPowerModeListener (unset) {
      if(unset !== true){
        if(!this.__lowPower_visibilitychange){
          this.__lowPower_visibilitychange = e => {
            const {visibilityState} = document;
            if(visibilityState === 'hidden'){
              this.CHANGE_LOW_POWER_MODE(1);
            }
          };
          document.addEventListener('visibilitychange', this.__lowPower_visibilitychange);
        }
      }else{
        document.removeEventListener('visibilitychange', this.__lowPower_visibilitychange);
      }
      this.setUserGestureLowPowerModeListener(unset);
    },
    setUserGestureLowPowerModeListener (unset) {
      this.CHANGE_LOW_POWER_MODE(0);

      clearTimeout(this._lowPowerMode_gesture_timer);
      if(unset !== true){
        // let init = this._lowPowerMode_gesture_timer === undefined;

        // term init
        let term = this.autoBrightnessTerm === undefined ? 60000 : this.autoBrightnessTerm * 1000;

        this._lowPowerMode_gesture_timer = setTimeout(() => {
          clearTimeout(this._lowPowerMode_gesture_timer2);
          this.CHANGE_LOW_POWER_MODE(1);
          this._lowPowerMode_gesture_timer2 = setTimeout(() => {
            if(this.lowPowerMode == 1){
              this.CHANGE_LOW_POWER_MODE(2);
            }
          }, 1000 * 60);
        }, term);
        this._setUserGestureLowPowerModeListener = this._setUserGestureLowPowerModeListener || this.setUserGestureLowPowerModeListener.bind(this);
        ['touchstart', 'click'].forEach(type => {
          document.addEventListener(type, this._setUserGestureLowPowerModeListener, {once: true});
        }, false);
      }else{
        ['touchstart', 'click'].forEach(type => {
          document.removeEventListener(type, this._setUserGestureLowPowerModeListener);
        })
      }
    },
    async roomEnter(options={}) {
      try {
        // dev
        console.log('[# 현재사용중인 API 서버 주소] : ',process.env.VUE_APP_API_URL);
        window.$roomVue = this
        window.$roomApi = this.$roomApi

        // room info
        let roomId = this.$route.params.roomId,
            roomUrlId = this.$route.params.roomUrlId

        if(!this.room || !this.room.roomId) {
           this.room = (
              await this.getRoom({ roomId, roomUrlId })
          ).data
        }

        roomId = this.room.roomId;

        try{
          document.title = `${this.room.roomUrlId || this.room.roomTitle} - 구루미 캠스터디 v3`;
        }catch(e){
          console.error(e);
        }

        // this.roomUserNickname = (
        //     await this.getMyNickname(this.room.roomId)
        // ).data

        commonEventListener(this.$roomApi)(this.$store)
        roomEventListener(this.$roomApi)(this.$store)

        // 입장 전 Device Setting에서 RoomInfo init
        await this.setRoomInfo(this.room.roomId);

        // 입장 전 UXInfo init
        // await this.setUXInfo(this.room.groupId);

        // TODO 장치 테스트 필요 없는 케이스
        let deviceSettings;
        let saveCoordiFunc;
        if(!options.retry) {
          const RoomSilentReload = await this.checkSilentReload();
          console.log('# reload : silent[%s]', !!RoomSilentReload);
          if(RoomSilentReload){
            deviceSettings = RoomSilentReload.deviceSettings;
            if(deviceSettings && deviceSettings.cameraStatus !== undefined){
                const devices = await GrmWebRTC.getUserDevice();
                if(deviceSettings.micStatus === 'none'
                  && devices.audioinput && devices.audioinput.length > 0
                ){
                  deviceSettings.micStatus = 'off';
                }
                if(deviceSettings.cameraStatus === 'none'
                  && devices.videoinput && devices.videoinput.length > 0
                ){
                  deviceSettings.cameraStatus = 'off';
                }
            }
          }else{
            const { settings, callFunc } = await this.showSetDevice()
            deviceSettings = settings
            saveCoordiFunc = callFunc
            // deviceSettings = await this.showSetDevice()

          }
          this.saveDeviceSettings({deviceSettings});
        }
        // use password
        if (this.room.definePasswd && !await this.isHost()) {
          this.passwd = await this.getPasswd();
        }

        if(deviceSettings){
          console.log('# deviceSettings :', JSON.stringify(deviceSettings, null, '  '));
        }else{
          deviceSettings = {...this.deviceSettings};
          console.log('# deviceSettings load default :', JSON.stringify(deviceSettings, null, '  '));
        }
        await this.enterToRoom({ roomId, roomUrlId }, deviceSettings, saveCoordiFunc)
      } catch (e) {
        console.error('## roomEnter failed', e)
        const env = process.env.NODE_ENV;

        if (await this.handleEnterAuthenticationError(e)) {
          return;
        }
        if (await this.handleEnterValidationError(e)) {
          return;
        }
        if (await this.handlePubSubConnectionError(e)) {
          return;
        }

        if(e.code === 'RT_INTERNAL_ERROR'){
          console.error('server internal error!!!', e);
          if(!options._err_refresh){
            // TODO: err
            options._err_refresh = true;
            setTimeout(() => {
              console.log('enter retry:', options._err_refresh);
              location.reload();
            }, 1000);
            return;
          }
        }

        this.$camsAlert({
          text: this.$t('camstudy.room.error.default'),
          ok: async () => {
            setTimeout(() => {
              location.reload()
            }, 1000)
          },
          cancel: async () => {
            if (!env || env === 'local') {
              window.location.href = '/'
            } else {
              window.location.href = process.env.VUE_APP_V2_ROOT_URL + process.env.VUE_APP_V2_HOME_PATH;
            }
          },
          onlyOk: false
        })
      }
    },
    async handleEnterAuthenticationError(e) {
      const authErrorList = [
        'Empty Refresh Token Cookie',
        'Invalid access token',
        'Expired Refresh Token',
        'Invalid Refresh Token',
        'Multiple Access Token Cookie',
        'Multiple Refresh Token Cookie',
        'Not found user'
      ];
      if (!authErrorList.includes(e.message) && e.code !== 'RT_AUTHENTICATION_FAILURE') {
        return false;
      }
      if (this.room.enterGuest) {
        this.$modal(RoomJoinGuest, {
          data: {
            joinGuest: this.handleGuestLogin
          }
        });
      } else {
        const subText = e.code === 'RT_AUTHENTICATION_FAILURE' ? this.$t('common.login.error.invalidToken') : e.message
        const message = this.$t('camstudy.room.error.loginRequired', {'0': subText})
        const url = getCamStudyV2RootUrl() + '/' + this.room.roomUrlId
        const routeLocation = process.env.NODE_ENV === 'local'
            ? {name: 'login', query: {redirect: location.pathname + location.hash}}
            : null
        await this.handleRedirect(message, url, routeLocation)
      }
      return true
    },
    async handleEnterValidationError(e) {
      const passwordErrorList = [
        'PASSWD_NOT_MATCHED',
        'PASSWD_REQUIRED'
      ];
      if (passwordErrorList.includes(e.message)) {
        this.$camsAlert({
          text: this.$t('room.password.fail'),
          ok: async () => {
            await this.roomEnter({retry: true});
          },
          onlyOk: true
        })
        return true;
      }

      if (e.message?.startsWith('BANNED_USER_')) {
        const parsedExpireDate = this.parseBanExpireDate(e.message)
        const expireDate = parsedExpireDate ? dayjs(parsedExpireDate).format('YYYY-MM-DD HH:mm:ss') : this.$t('camstudy.room.error.banned.message.forever')
        await this.handleRedirect(this.$t('camstudy.room.error.banned.message.expireDate', {'0': expireDate}), this.v2CamsHomeUrl, null)
        return true;
      }

      const redirectErrors = {
        'WAITING_ROOM_REQUIRED': this.$t('room.rejoin'),
        'NONE_ROOM': this.$t('room.closed'),
        'ENDED': this.$t('room.closed'),
        'NONE_ROOM_SETTING': this.$t('room.notExist'),
        'DENY_DEVICE_TYPE': this.$t('room.deviceNotAllowed'),
        'BANNED_ROOM_USER': this.$t('camstudy.room.error.banned.message.default'),
        'NOT_INVITE_CAM_STUDY_USER': this.$t('camstudy.room.error.notInvited'),
        'NOT_MATCHED_GROUP': this.$t('camstudy.room.error.notMatchedGroup'),
        'NOT_AVAILABLE_GUEST_USER': this.$t('camstudy.room.error.noGuest'),
        'LIMIT_ROOM_JOIN_CNT': this.$t('camstudy.room.error.userLimitExceeded'),
        'NOT_FOUND_OTP_USER': this.$t('camstudy.room.error.notOtpUser')
      }
      if (Object.hasOwn(redirectErrors, e.message)) {
        await this.handleRedirect(redirectErrors[e.message], this.v2CamsHomeUrl, null)
        return true;
      }
      return false;
    },
    parseBanExpireDate(message) {
      const expireDate = message.replace('BANNED_USER_', '')
      return expireDate === 'null' ? null : expireDate
    },
    async handlePubSubConnectionError(e) {
      const connectionErrors = {
        'FAILED_CREATE_OLD_CONNECTION': this.$t('room.connectionState.msg.concurrentUser'),
        'FAILED_CREATE_CONNECTION': this.$t('room.connectionState.msg.disconnected'),
      };
      if (!Object.hasOwn(connectionErrors, e.message)) {
        return false;
      }
      this.$camsAlert({
        text: connectionErrors[e.message] || this.$t('room.connectionState.msg.disconnected'),
        ok: async () => {
          location.reload()
        },
        onlyOk: true
      })
      return true;
    },
    async enterToRoom(options = {}, deviceSettings, saveCoordiFunc) {
      // create params
      let enterParams = _.merge(
        {
          roomId: this.$route.params.roomId,
          roomUrlId:
            this.$route.hash &&
            this.$route.hash.length > 0 &&
            this.$route.hash.substring(1),
          passwd: this.passwd,
          nickname: this.enterReq.nickname,
          cameraStatus: deviceSettings.cameraStatus || (
              deviceSettings.video.deviceId
                  ? 'on'
                  : (deviceSettings.video.deviceId === false ? 'none' : 'off')
          ),
          micStatus: deviceSettings.micStatus || (
              deviceSettings.audio?.deviceId
                  ? 'on'
                  : (deviceSettings.audio?.deviceId === false ? 'none' : 'off')
          ),
          speakerStatus: deviceSettings.speakerStatus || (
              deviceSettings.audiooutput?.deviceId
                ? 'on'
                : (deviceSettings.audiooutput?.deviceId === false ? 'none' : 'off')
          ),
          useNoiseCancel: deviceSettings.audio?.useNoiseCancel,
          networkType: Device.networkType(),
          deviceType: Device.isMobile() ? 'mobile' : 'pc',
          deviceModel: Device.deviceInfo().device?.model,
          osName: Device.deviceInfo().os?.name,
          osVersion: Device.deviceInfo().os?.version,
          clientType: Device.deviceInfo().client?.type,
          clientName: Device.deviceInfo().client?.name,
          clientVersion: Device.deviceInfo().client?.version,
        },
        options
      )

      await this.enter({
        enterParams,
        deviceSettings
      })

      if (saveCoordiFunc && typeof saveCoordiFunc === 'function') {
        await saveCoordiFunc()
      }

      this.readyToEnter = true

      this.setVisibilityLowPowerModeListener();
    },
    setUserNickname({ nickname }) {
      this.enterReq.nickname = nickname
    },
    leaveRoomToggle(state) {
      this.isLeaveRoom = state
    },
    async showSetDevice() {
      this.isShowSetDevice = true
      return new Promise((resolve, reject) => {
        try {
          this.$once('deviceTestComplete', ({ settings, callFunc }) => {
            this.isShowSetDevice = false
            console.log('# deviceTestComplete :', JSON.stringify(settings, null, '  '));
            resolve({ settings, callFunc })
          })
        } catch (e) {
          reject(e)
        }
      })
    },
    async handleGuestLogin(nickname){
      await this.guestLogin(nickname);
      this.$modal('RoomJoinGuest');
      await this.roomEnter();
    },
    async getPasswd(){
      return await new Promise((res, rej) => {
        try {
          this.$camsAlert({
            title: this.$t('room.password.invitationCode'),
            type: 'input',
            ok: (value) => {
              return res(value)
            },
            onlyOk: true
          })
        } catch(e) {
          console.log(e)
          return rej(e)
        }
      });
    },
    async isHost(){
      let curUser = await this.currentUser();
      let userId = curUser?.data?.user?.userId;

      if(userId == this.room.userId){
        return true;
      }else{
        return false;
      }
    },
    async kickRoomUser(e) {
      // await this.$roomApi.disconnectClient()

      // this.unsetBeforeUnloadEvent()
      // this.$el.remove()
      // this.$destroy()

      let kicker = this.$t('common.emcee');
      const roomUser = this.getRoomUser(e.userId);
      if (roomUser && roomUser.roomUserRole?.roleId) {
        if (this.isOpener(e.userId) && this.isParticipantRole(roomUser)) {
          kicker = this.$t('common.speaker');
        } else {
          kicker = this.$t(`common.${roomUser.roomUserRole.roleId}`);
        }
      }

      this.$camsAlert({
        text: this.$t('room.ban.message.default'),
        ok: () => {
          if (this.roomSetting.useClosingWindow) {
            window.close();
          } else {
            window.location.href = this.v2CamsHomeUrl;
          }
        },
        onlyOk: true
      })
    },
    closeExtendMenu(){
      this.isOpenExtendMenu = false;
    },
    toggleNewWindowMenu(){
      this.$refs.newWindowMenu.toggle()
    },
    onFullscreenChange(){
      this.SET_FULL_SCREEN(this.getDocument().fullscreen);
    },
    onTransitionend(){
      this.getDefaultView().dispatchEvent(new Event('resize'));
    },
    handleRedirect(message, url, routeLocation) {
      return new Promise((resolve) => {
        this.$camsAlert({
          text: message,
          ok: () => {
            if (routeLocation) {
              this.$router.push(routeLocation)
            } else {
              window.location.href = url;
            }
            resolve()
          },
          onlyOk: true
        })
      })
    },
    onClosePremiumPlusModal(){
      this.isOpenPlusModal = false;
    },
  },
  watch: {
    rv_test(val) {
      if (val) {
        this.$refs.pipVideo.toggle();
      }
    },
    connectionState(state) {
      if(state === 'disconnected'){
        this.$confirm({
          text: this.$t('room.connectionState.msg.disconnected')
            + '<br>' + this.$t('room.connectionState.msg.reEnter'),
          ok: () => {
            this.reloadRoom({silent: false});
          },
          cancel: () => {
            this.reqLeave();
            closeWindow();
          }
        });
      }
    },
    'personalSetting.autoBrightnessTerm' : {
      handler(val) {
        this.autoBrightnessTerm = val;
        this.setUserGestureLowPowerModeListener();
      },
      deep: true,
    },
  },
}

const _Events = {
  room_reload(e) {
    this.reloadRoom({
        silent: !this.isShowSetDevice
    });
  },
  room_user_kickRoomUser(e) {
    this.kickRoomUser(e)
  },
  room_user_kickAllRoomUser(e) {
    if(!this.hasEmceeRole(this.me)) {
      this.kickRoomUser(e)
    }
  },
  noise_cancel_failed(data) {
    this.$camsAlert({
      text: this.$t('room.noiseCancelFail'),
      onlyOk: true,
    })
  },
  room_stt_failed(e) {
    this.$camsAlert({
      text: this.$t('room.roomSttFail'),
      onlyOk: true,
    })
  },
  room_data_init() {
    this.ROOM_CONNECTED();
  },
  room_leaved (e) {
      switch (e.data.reason) {
        case 'duplicate_login_same_session':
        case 'duplicate_login':
          this.$camsAlert({
            text: this.$t('room.duplicateUser'),
            ok: () => {
              window.location.href = this.v2CamsHomeUrl
            },
            onlyOk: true
          })
          break;
        case 'ws_session_expired':
          this.$camsAlert({
            text: this.$t('room.wsSessionExpired'),
            ok: () => {
              window.location.href = this.v2CamsHomeUrl
            },
            onlyOk: true
          })
          break;
        case 'room_disconnected':
          this.$camsAlert({
            text: this.$t('room.roomDisconnected'),
            ok: () => {
              window.location.href = this.v2CamsHomeUrl
            },
            onlyOk: true
          })
          break;

        case 'logout':
          this.$camsAlert({
            text: this.$t('room.logout'),
            ok: () => {
              window.location.href = this.v2CamsHomeUrl
            },
            onlyOk: true
          })
          break;
      }

      this.unsetBeforeUnloadEvent();
      this.$el.remove();
      this.$destroy()
  },
  room_user_leave (e) {
    const { userId, reason } = e.data
    if (!this.isMe(userId)) {
      return
    }

    switch(reason){
      case 'PROTOCOL_ERROR':
      case 'NO_CLOSE_FRAME':
        this.unsetBeforeUnloadEvent()
        location.reload()
        break
      default:
        break
    }
  },
  room_end (e) {
    this.unsetBeforeUnloadEvent();
    let exitTimer = setTimeout(() => {
      if (this.roomSetting.useClosingWindow) {
        window.close();
      } else {
        window.location.href = this.v2CamsHomeUrl;
      }
    }, 3000);

    this.$camsAlert({
      text: this.$t('room.end'),
      ok: () => {
        clearTimeout(exitTimer);
        if (this.roomSetting.useClosingWindow) {
          window.close();
        } else {
          window.location.href = this.v2CamsHomeUrl;
        }
      },
      onlyOk: true
    })

  },
  room_doc_convertError (e) {
    if (this.isMe(e.userId)) {
      this.$camsAlert({
        text: this.$t('doc.convert.fail.msg'),
        onlyOk: true
      });
    }
  },
  completed_meeting_note_summary (e) {
    if (this.isMe(e.userId)) {
      this.$camsAlert({
        text: this.$t('extendMenu.meetingNote.summary.alert.event.completed'),
        onlyOk: true
      });
    }
  },
  failed_meeting_note_summary (e) {
    if (this.isMe(e.userId)) {
      this.$camsAlert({
        text: this.$t('extendMenu.meetingNote.summary.alert.event.failed'),
        onlyOk: true
      });
    }
  },
  room_enter_failed (e) {
    const { reason } = e.data

    switch (reason) {
      case 'NOT_AUTHORIZED_USER':
        this.$camsAlert({
          text: this.$t('room.unableConnectUser'),
          ok: () => {
            this.unsetBeforeUnloadEvent();
            window.location.href = this.v2CamsHomeUrl
          },
          onlyOk: true
        })
        break;
      default:
        break;
    }
  },
  room_cbt_end (e) {
    if (this.isParticipantRole()) {
      const myData = e.data.roomCbtUserScoreList.find(user => user.userId === this.me.userId);
      if (myData) {
        this.$camsAlert({
          title: this.$t('roomCbt.endResult.title'),
          text: this.$t('roomCbt.endResult.totalScore', { '0' : !myData.totalScore ? 0 : myData.totalScore }),
          onlyOk: true
        });
      }
    }
  },
  room_cstudy_changeRoomType (e) {
    const v2Url = e.data.v2Url;

    const div = document.createElement('div')
    document.body.appendChild(div)
    new Vue({
      i18n,
      render: h => h(GrmTransitionLoading, {
        props: {
          roomLevel: e.data.roomLevel
        }
      })
    }).$mount(div)

    setTimeout(() => {
      window.location.href = v2Url;
    }, 7000);
  },
}

</script>

<style lang="scss">
html, body {
  overscroll-behavior: contain;
}
</style>
<style lang="scss" scoped>
.room {
  height: 100%;
  background-color: #eaeaea;
  display: flex;
  position: relative;

  .room-setting-layer {
    z-index: 5;
  }
}
.room-main {
  min-width: 0;
  flex: 1;
  background: #1F1F1F;
  position: relative;
  z-index: 1;
}
.room-container {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

// Component
.room-main-component {
  height: 100%;
}
.room-controls-component {
  height: 50px;
  position: relative;
  z-index: 3;
}
.room-call-sub-video-component {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.room-menu-component {
  width: 60px;
  z-index: 4;
}
.room-setting-component {
  width: 360px;
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: calc(60px + 6px);
  z-index: 2;
}
.room-sticker-modal-component {
  width: 80px;
  position: absolute;
  top: calc(50px + 6px);
  right: 0;
  bottom: 6px;
  left: calc(60px + 6px);
  z-index: 2;
}
[grm-device-mobile] {
  @media (max-width: 768px) {
    .room-container {
      width: 100%;
    }
    .room-setting-component{
      width: calc(100% - 72px);
    }
  }
}
</style>